
/* injects from baggage-loader */
require('./style.scss');

import React from "react";
import Slider from "react-slick";
import Config from "../../../config/main";

import zlatnikSlider1Pic from '../../../images/ZlatnikSlider/1.png';
import zlatnikSlider2Pic from '../../../images/ZlatnikSlider/2.png';

import betonSilderPic1 from '../../../images/betoneSilder/1.png';
import betonSilderPic2 from '../../../images/betoneSilder/2.png';
import betonSilderPic3 from '../../../images/betoneSilder/3.png';
import betonSilderPic4 from '../../../images/betoneSilder/4.png';


const ZlatniksliderImages = [zlatnikSlider1Pic, zlatnikSlider2Pic];
const BetonesliderImages = [betonSilderPic1, betonSilderPic2, betonSilderPic3, betonSilderPic4];

const CustomSlider = () => {

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: Config.enableSliderForBetone ? 10000 : 3000,
        className: 'image-slider-container',
    };

    const images = Config.enableSliderForBetone ? BetonesliderImages : ZlatniksliderImages;
    return (
        <Slider {...settings}>
            {images.map(pic => <div key={pic} style={{ background: `url('${pic}') center/cover` }} />)}
        </Slider>
    )
}

export default CustomSlider;